module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', {
    attrs: {
      "leftVisible": false,
      "uniform-colour": ""
    }
  }, [_c('v-app-bar', {
    attrs: {
      "slot": "header",
      "flat": "",
      "dark": "",
      "dense": "",
      "color": "blue"
    },
    slot: "header"
  }, [_c('v-toolbar-title', [_vm._v("John and June Citizen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('ToolbarSearch', {
    on: {
      "search": _vm.search
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "nudge-width": 200
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "dark": ""
          }
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.page.saveAll()
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Save All")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "raised-desktop"
  }, [_c('Flow', {
    attrs: {
      "id": _vm.flowId
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "raised-desktop white-background",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('StepDesigner'), _vm._v(" "), _c('FlowActivity')], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "300",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "transition": "v-fade-transition",
      "persistent": ""
    },
    model: {
      value: (_vm.makingActivity),
      callback: function($$v) {
        _vm.makingActivity = $$v
      },
      expression: "makingActivity"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('v-textarea', {
    attrs: {
      "id": "activityDescription"
    },
    model: {
      value: (_vm.page.newComment),
      callback: function($$v) {
        _vm.$set(_vm.page, "newComment", $$v)
      },
      expression: "page.newComment"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23889970"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/flow/Workflow.vue
// module id = 2482
// module chunks = 1